import type { ReactNode } from "react";
import { ScrollArea } from "../../ui/scroll-area";

export function ReaderOverlayPanel({
  title,
  titleAccessory,
  action,
  children,
  contentClassName = "p-2",
  onClose,
}: {
  title: string;
  titleAccessory?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  contentClassName?: string;
  onClose: () => void;
}) {
  return (
    <div className="fixed inset-0 z-40 bg-background/35 backdrop-blur-[2px] animate-in fade-in" role="presentation" onClick={onClose}>
      <section
        className="mx-auto mt-20 max-h-[72vh] w-[min(calc(100vw-1rem),42rem)] overflow-hidden rounded-2xl border bg-popover text-popover-foreground shadow-2xl animate-in zoom-in-95 slide-in-from-top-2"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={event => event.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-4 border-b p-4">
          <div>
            <div className="flex items-center gap-2">
              <h2 className="font-semibold">{title}</h2>
              {titleAccessory}
            </div>
          </div>
          {action}
        </div>
        <ScrollArea className={`max-h-[56vh] ${contentClassName}`}>{children}</ScrollArea>
      </section>
    </div>
  );
}
